import Vue from 'vue'
import Router from 'vue-router'
import Login from "@/views/login/login"
import ReportDetails from "../views/DetailPages/reportDetails"
import EventDetails from "../views/DetailPages/eventDetails"
import { ExecuteAssessmentTaskRouter } from '../utils/routeData'
import ExecuteAssessmentTask from '../views/executeTasks/executeAssessmentTask'

Vue.use(Router)
// 重写push可以调整到当前页面
let originPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originPush.call(this, location).catch(err => err)
}
// 仅添加不重复路由方法
Router.prototype.addRouteNotAdded = function (route) {
    try {
      if (route && route.path && route.component) {
          if (route.name) {//有name字段说明不是根目录
              if (this.getRoutes().some(r => r.name && r.name === route.name)) {
                  console.warn(`Duplicate route: ${route.name}`)
                  return
              }
          }
          Router.prototype.addRoute.call(this, route)
      }
    } catch (err) {
        console.error(err.message)
    }
}

// 注册路由
export default new Router({
  // mode:'history', // 默认为'hash'模式
  // base: '/permission/', // 添加跟目录,对应服务器部署子目录
  // routes: constantRouterMap
  routes: [
    {
      path: '/login',
      name: "login",
      component: Login,
    },
    {
      path: '/reportDetails',
      name: "reportDetails",
      component: ReportDetails,
    },
    {
      path: '/eventDetails',
      name: "eventDetails",
      component: EventDetails,
    },
    Object.assign({ component: ExecuteAssessmentTask }, ExecuteAssessmentTaskRouter)
  ]})